<template>
  <div class="addstategyNew">
    <div class="section">
      <div class="stategyHeader">
        <div @click="toStrategy()">
          <i class="iconfont icon-fanhui1"></i>
          <span class="toStyle">{{$t('strategy.to')}}</span>
        </div>
        <span>{{$t('strategy.add_strategy')}}</span>
      </div>
      <div class="stategyBody">
        <!-- 步骤条 -->
        <!-- "width:500px; -->
        <div style="width:100%;padding: 50px 0 0;">
          <!-- <p class="">标题</p> -->
          <el-steps
            style="display: flex;justify-content: center;"
            class="eb-steps"
            :active="currentStep"
            align-center
            finish-status="finish"
          >
            <el-step class="stepClass" :title="$t('strategy.policy_information')">
              <i class="el-icon-success" style="font-size:21px;" v-if="currentStep!=0" slot="icon"></i>
            </el-step>
            <el-step class="stepClass" :title="$t('strategy.uprade_type')">
              <i class="el-icon-success" style="font-size:21px;" v-if="currentStep>1" slot="icon"></i>
            </el-step>
            <el-step :title="$t('strategy.associated_device')">
              <i class="el-icon-success" style="font-size:21px;" v-if="currentStep >2" slot="icon"></i>
            </el-step>
          </el-steps>
        </div>
        <!-- 步骤内容 -->
        <div class="gridbox" slot="content" style="width:80%;" v-if="currentStep==0">
          <el-form :model="addStrategyData" :rules="formRules" ref="form" size="small">
            <div class="form-group grid">
              <div class="form-groupname">
                <span>{{ $t('strategy.policy_information') }}</span>
              </div>
              <!-- 策略名称 -->
              <el-form-item :label="`${$t('strategy.strategy_name')}：`" prop="strategyName">
                <el-input :maxlength="32" v-model="addStrategyData.strategyName" clearable></el-input>
              </el-form-item>
              <!-- 策略描述 -->
              <el-form-item :label="`${$t('strategy.strategy_desc')}：`" prop="strategyDesc">
                <el-input
                  type="textarea"
                  :placeholder="$t('firmware.enter_content')"
                  v-model="addStrategyData.strategyDesc"
                  :maxlength="100"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <!-- 升级固件 -->
              <el-form-item prop="strategyFirmware" :label="`${$t('strategy.strategy_firmware')}：`">
                <!-- :placeholder="$t('project.defaultProject')" -->
                <el-select
                  v-model="addStrategyData.strategyFirmware"
                  placeholder
                  popper-class="select-search-recharge"
                >
                  <el-option
                    v-for="item in firmwaresData"
                    :key="item.id"
                    :value="item.id"
                    :label="item.firmware"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- 固件类型 -->
              <el-form-item prop="strategyType" :label="`${$t('strategy.strategy_type')}：`">
                <!-- :placeholder="$t('project.defaultProject')" -->
                <el-select
                  v-model="addStrategyData.strategyType"
                  placeholder
                  popper-class="select-search-recharge"
                >
                  <el-option
                    v-for="item in firmwaretypelist"
                    :key="item.id"
                    :value="item.id"
                    :label="item.typeName"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- 波特率 -->
              <el-form-item prop="strategyBaudrate" :label="`${$t('strategy.strategy_baudrate')}：`">
                <!-- :placeholder="$t('project.defaultProject')" -->
                <el-select
                  v-model="addStrategyData.strategyBaudrate"
                  placeholder
                  popper-class="select-search-recharge"
                >
                  <el-option
                    v-for="item in bratelist"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- 时区 -->
              <!-- <el-form-item prop="timezone" :label="`${$t('datalogger.timezone')}：`">
                <el-select v-model="addStrategyData.timezone" popper-class="select-search-recharge">
                  <el-option
                    v-for="(val, key) in availableTimezone"
                    :key="key"
                    :label="val.label"
                    :value="key"
                  ></el-option>
                </el-select>
              </el-form-item> -->
              <!-- 生效时间 -->
              <el-form-item  prop="strategyTime" :label="`${$t('device.device_upgradeTime')}：`" >
                <div style="display: flex;align-items: center;width:100%;justify-content: space-between;">
                    <el-date-picker
                      v-model="addStrategyData.strategyTime"
                      type="date"
                      class="eb-rangepicker eb-timepicker"
                      :clearable="false"
                      :editable="false"
                      align="left"
                      unlink-panels
                      :placeholder="$t('device.pleaseDate')"
                      :picker-options="pickerrangeOptions"
                      style="width:70%;"
                      @change="setDefaultTime"
                      popper-class="select-date1"
                     />
                     <!-- 开始时间 -->
                     <el-time-picker
                       v-model="startTime"
                       :placeholder="$t('actionLog.startTime')"
                       popper-class="select-date2"
                       :clearable="false"
                       :editable="false"
                       style="width:14%;"
                       :disabled="addStrategyData.strategyTime == ''"
                       :picker-options="startOpts">
                     </el-time-picker>
                   
                     <!-- 结束时间 -->
                     <el-time-picker
                       v-model="endTime"
                       :placeholder="$t('actionLog.endTime')"
                       popper-class="select-date2"
                       :clearable="false"
                       :editable="false"
                       style="width:14%;"
                       :disabled="addStrategyData.strategyTime == ''"
                       :picker-options="endOpts" >
                     </el-time-picker>
                </div>
              </el-form-item>
              <!-- 升级方式 -->
              <el-form-item
                :label="`${$t('strategy.uprade_type')}：`"
                prop="upradeType"
                class="el-form-group-item"
              >
                <el-radio-group
                  v-model="addStrategyData.upradeType"
                  v-removeAriaHidden
                  class="eb-radio-group"
                >
                  <el-radio :label="0">{{$t('strategy.uprade_name')}}</el-radio>
                  <!-- <el-radio :label="1">{{$t('strategy.uprade_name1')}}</el-radio> -->
                </el-radio-group>
              </el-form-item>
              <!-- 提醒描述 -->
              <el-form-item :label="`${$t('strategy.remind_desc')}：`" prop="remindDesc">
                <el-input
                  type="textarea"
                  :placeholder="$t('firmware.enter_content')"
                  v-model="addStrategyData.remindDesc"
                  :maxlength="100"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <!-- 默认提醒 -->
              <el-form-item
                prop="default_desc"
                :label="`${$t('strategy.default_desc')}：`"
              >{{ $t('strategy.default_desc1') }}</el-form-item>
            </div>
          </el-form>
        </div>
        <!-- 升级方式 -->
        <div class="gridbox" slot="content" style="width:80%;" v-if="currentStep==1">
          <div
            class="form-group grid"
            style="display: flex;flex-direction: column;padding: 26px 46px 31px;;"
          >
            <div class="form-groupname">
              <span>{{ $t('strategy.stategyDetail5') }}</span>
            </div>
            <div style="width:100%;">
              <el-form :model="Upgrademethod"  ref="form" size="small">
                <!-- 升级方式 -->
                <el-form-item
                  :label="`${$t('strategy.uprade_type')}：`"
                  prop="upradeType"
                  class="el-form-group-item"
                >
                  <el-radio-group
                    v-model="Upgrademethod.otaupradeType"
                    v-removeAriaHidden
                    class="eb-radio-group"
                  >
                    <el-radio :label="0">{{ $t('strategy.ONE_UP') }}</el-radio>
                    <el-radio :label="1">{{ $t('strategy.MO_UP') }}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <!-- 关联设备 -->
        <div class="gridbox" slot="content" style="width:80%;" v-if="currentStep==2">
          <div
            class="form-group grid"
            style="display: flex;flex-direction: column;padding: 26px 46px 31px;;"
          >
            <div class="form-groupname">
              <span>{{ $t('strategy.associated_device') }}</span>
            </div>
            <div style="width:100%;">
             <el-form :model="Addindividually" :rules="PNformRules" ref="PNform" size="small" v-if="Upgrademethod.otaupradeType == 0">
                <!-- 单个PN添加 -->
                <el-form-item :label="`PN：`" prop="DataCollectorPn">
                   <el-input  v-model="Addindividually.DataCollectorPn" clearable></el-input>
                </el-form-item>
              </el-form>
              <div v-if="Upgrademethod.otaupradeType == 1">
               <el-form class="grid upload-container">
                 <!-- <p>{{$t('firmware.Firmware_description')}}</p> -->
                 <el-form-item label=" ">
                   <div class="upload-contents">
                     <button type="button" class="upload-buttonEquipment" @click.prevent="$refs.fileUploaderCollector.click()">
                       <i class="iconfont icon-shangchuan"></i>
                       <!-- {{$t('firmware.Upload1')}} -->
                     </button>
                     <div class="upload-tip">{{ `${$t('firmware.Upload1')} (${$t('firmware.limit1')})` }}</div>
                     <input type="file" class="upload-input" ref="fileUploaderCollector" accept=".xlsx"
                       @change="uploadCollector($event)" />
                   </div>
                 </el-form-item>
               </el-form>
               <div class="fileYupe" v-if="OTAfile"><i class="el-icon-folder-opened" style="margin-right: 4px;"></i>{{OTAfile.name}}</div>
               <div style="margin-left:10px">
                 <div style="font-size:14px;color:#F56C6C;" class="upload-tip">{{ $t('strategy.limits') }}</div>
                 <img  src="@/assets/img/importOTAPnExampleZh.png" alt="">
               </div>

             </div>
            </div>
          </div>
        </div>
        <!-- 步骤按钮 -->
        <div style="display: flex;justify-content: center;margin: 25px 0;">
          <div v-if="currentStep==0">
            <el-button class="btn btn-light" @click="toStrategy()">
              <span style="width: 100px;">{{$t('strategy.go_back')}}</span>
            </el-button>
            <el-button  class="btn btn-dark" @click="goNext()">
              <span style="width: 100px;">{{$t('strategy.Next')}}</span>
            </el-button>
          </div>
          <div v-if="currentStep==1">
            <el-button class="btn btn-light" @click="goTop()">
              <span style="width: 100px;">{{$t('strategy.TOP')}}</span>
            </el-button>
            <el-button class="btn btn-dark" @click="goNextNum()">
              <span style="width: 100px;">{{$t('strategy.Next')}}</span>
            </el-button>
          </div>
          <div v-if="currentStep==2">
            <el-button class="btn btn-light" @click="goTop(true)">
              <span style="width: 100px;">{{$t('strategy.TOP')}}</span>
            </el-button>
            <el-button style="margin-left: 10px;" class="btn btn-dark" @click="goConfirm()">
              <span style="width: 100px;">{{$t('strategy.confirm')}}</span>
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import textArea from "@/assets/EBUI/components/TextArea/index";
export default {
  components: {
    textArea
  },
  data() {
    var validatepn = (rule, value, callback) => {
         var ref = /^((?=.*[a-zA-Z])[a-zA-Z\d]{14}){1}([a-zA-Z\d]{4})?$/
        if (!value) {
          callback(new Error(this.$t("message.pn_is_required")));
        }else if(!ref.test(value)){
          callback(new Error(this.$t('signup.pnformat')));
        }else{
            callback()
        }
      };
    return {
        startTime: '',   // Date 或空
        endTime: '',
      // 新增策略
      addStrategyData: {
        strategyName: "",
        strategyDesc: "",
        strategyFirmware: "",
        strategyType: "",
        strategyBaudrate: "9600",
        strategyTime: "",
        upradeType: 0,
        remindDesc: "",
        timezone: "28800"
      },
      OTAfile:null,
    //   升级方式
      Upgrademethod:{
        otaupradeType:0,
      },
    //   单个添加采集器
      Addindividually:{
        DataCollectorPn:'',
      },
      // 数采器列表
      dataloggerList: [],
      // 新增表单校验
      formRules: {
        strategyName: [
          {
            required: true,
            message: this.$t("strategy.message_name"),
            trigger: ["blur", "change"]
          }
        ],
        strategyDesc: [
          {
            required: true,
            message: this.$t("strategy.message_desc"),
            trigger: ["blur", "change"]
          }
        ],
        strategyFirmware: [
          {
            required: true,
            message: this.$t("strategy.message_firmware"),
            trigger: ["blur", "change"]
          }
        ],
        strategyType: [
          {
            required: true,
            message: this.$t("strategy.message_type"),
            trigger: ["blur", "change"]
          }
        ],
        strategyBaudrate: [
          {
            required: true,
            message: this.$t("strategy.message_baudrate"),
            trigger: ["blur", "change"]
          }
        ],
        // timezone: [
        //   {
        //     required: true,
        //     message: this.$t("strategy.message_baudrate"),
        //     trigger: ["blur", "change"]
        //   }
        // ],
        strategyTime: [
          {
            required: true,
            message: this.$t("strategy.message_time"),
            trigger: ["blur", "change"]
          }
        ],
        upradeType: [
          {
            required: true,
            message: this.$t("strategy.message_uprade_type"),
            trigger: ["blur", "change"]
          }
        ]
      },
      PNformRules:{
        DataCollectorPn: [
          { required: true, validator: validatepn,  trigger: ["blur", "change"] }
        ],
      },
      loadingDevice: false,
      pagination: {
        currentPage: 1,
        total: 0,
        pagesize: 15
      }, // 分页数据
      // 步骤条
      currentStep: 0,
      // 时区过滤
      availableTimezone: this.$filter.timezone,

      // 波特率
      bratelist: [
        {
          //默认
          // label: i18n.t("device.default"),
          label: "0bps",
          value: "0"
        },
        {
          label: "1200bps",
          value: "1200"
        },
        {
          label: "2400bps",
          value: "2400"
        },
        {
          label: "4800bps",
          value: "4800"
        },
        {
          label: "9600bps",
          value: "9600"
        },
        {
          label: "19200bps",
          value: "19200"
        },
        {
          label: "38400bps",
          value: "38400"
        },
        {
          label: "57600bps",
          value: "57600"
        },
        {
          label: "115200bps",
          value: "115200"
        }
      ],
      // 批量操作勾选
      selectedDevice: [],
      selectedDevice1: [],
      emptyText: false,
      // 搜索弹出
      showSearch: false,
      search: {
        status: "",
        alias: ""
      },
      status: {
        0: {
          num: 0,
          label: this.$t("datalogger.Normal"),
          name: "normal"
        },
        1: {
          num: 0,
          label: this.$t("datalogger.Offline"),
          name: "offline"
        }
      },
      // 添加策略成功
      showSucVisible: true,
      // 添加策略失败
      showFailVisible: false,
      // 固件包数据
      firmwaresData: [],
      // 固件类型
      firmwaretypelist: [],
      pickerrangeOptions: {   
        /* ③ 只允许选“明天”这一天 */
        disabledDate(time) {
          const tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);
          tomorrow.setHours(0, 0, 0, 0);
          // 只允许选“明天及以后”
          return time.getTime() < tomorrow.getTime();
        },
      },
      timpickerrangeOptions: {   
        selectableRange: '03:00:00 - 04:59:59',
      },
    };
  },
  created() {
    this.getFirmwares();
    this.getFirmwaresType();
  },
  methods: {
    setDefaultTime(val) {
      if (!val) {          // 用户把日期清空了
        this.startTime = ''
        this.endTime   = ''
        return
      }
      const d = new Date(val)
      this.startTime = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 3, 0, 0)
      this.endTime   = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 5, 0, 0)
    },
   //点击选择文件的按钮(选择成功后直接关闭弹窗)
   uploadCollector (event) {
      this.fileList = []
      this.$nextTick(() => {
        this.$refs.fileUploaderCollector.value = null;
      });
      let file = event.target.files[0];
      let suffix = file.name.split(".").slice(-1)[0];
      if (suffix !== "xlsx") {
        this.$message.error(this.$t("firmware.limit1"));
        return;
      }
      setTimeout(() => { this.$message.success(this.$t("createPlant.uploadSuccess")) }, 500)
      this.OTAfile = event.target.files[0];
    },
    // 查询固件类型
    getFirmwaresType() {
      this.$request
        .getUPG("/upg/api/auth/web/device/upgradeType/getTypeByUid")
        .then(res => {
          if (res.code == 0) {
            this.firmwaretypelist = res.data.items;
          }
        });
    },
    // 查询固件包
    getFirmwares() {
      let parmas = {
        deleteFlag: 0,
        pageSize: 100,
        page: 0,
        i18n: this.$lang.currentLang
      };
      this.$request
        .getUPG("/upg/api/auth/web/shineDess/collector/upgrade/queryFiremware", parmas)
        .then(res => {
          if (res.code == 0) {
            this.firmwaresData = res.data.items;
          }
        });
    },
    // 下一步
    goNext() {
        console.log(this.$filter.formatDate(this.startTime), this.$filter.formatDate(this.endTime));
      this.$refs.form.validate(valid => {
        if (!valid) return false;
        console.log('this.Addindividually',this.firmwaresData.filter(i => i.id == this.addStrategyData.strategyFirmware)[0].firmware);
        this.currentStep++;
      });
    },
    goNextNum(){
         this.currentStep++;
    },
    // 上一步
    goTop(val) {
      this.currentStep--;
      if(val){
        this.$refs.PNform.resetFields();
      }
    },
    // 确认添加策略
    goConfirm() {
      if(this.Upgrademethod.otaupradeType == 0){
        this.$refs.PNform.validate(valid => {
        if (!valid) return false;
        let params = {
           operate:'insert',
           pn:this.Addindividually.DataCollectorPn,
           strategyName: this.addStrategyData.strategyName,
           strategyDesc: this.addStrategyData.strategyDesc,
           firmwareId: this.addStrategyData.strategyFirmware,
           firmwareName: this.firmwaresData.filter(i => i.id == this.addStrategyData.strategyFirmware)[0].firmware,
           firmwareTypeId: this.addStrategyData.strategyType,
           upgradeType: this.firmwaretypelist.filter(i => i.id == this.addStrategyData.strategyType)[0].upgradeType,
           baudrate: this.addStrategyData.strategyBaudrate,
           effectTime: this.$filter.formatDate(this.startTime),
           expireTime: this.$filter.formatDate(this.endTime),
        //    devices: this.selectedDevice1,
           strategyTypeId: 0,
        //    strategyType: this.addStrategyData.upradeType,
           description: this.addStrategyData.remindDesc,
        //    timezone: this.addStrategyData.timezone,
           i18n: this.$lang.currentLang
         };
         console.log(params,'params');
       this.$request
          .get("deviceFirmwareUpgradeStrategy", params)
          .then(res => {
            if (res.err==0) {
            this.$message.success(this.$t("strategy.Upgrade_result"))
          }else{
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
            this.toStrategy();
          });
      });
     }else{
        let params = {
           operate:'insert',
        //    file:this.OTAfile,
           strategyName: this.addStrategyData.strategyName,
           strategyDesc: this.addStrategyData.strategyDesc,
           firmwareId: this.addStrategyData.strategyFirmware,
           firmwareName: this.firmwaresData.filter(i => i.id == this.addStrategyData.strategyFirmware)[0].firmware,
           firmwareTypeId: this.addStrategyData.strategyType,
           upgradeType: this.firmwaretypelist.filter(i => i.id == this.addStrategyData.strategyType)[0].upgradeType,
           baudrate: this.addStrategyData.strategyBaudrate,
           effectTime: this.$filter.formatDate(this.startTime),
           expireTime: this.$filter.formatDate(this.endTime),
           strategyTypeId: 0,
           description: this.addStrategyData.remindDesc,
        //    timezone: this.addStrategyData.timezone,
           i18n: this.$lang.currentLang
         };
       this.$request
          .OTAuploadCollector(this.OTAfile, { action: 'deviceFirmwareUpgradeStrategy', ...params })
          .then(res => {
            if (res.err==0) {
            this.$message.success(this.$t("strategy.MO_text")+res.dat[0]+this.$t("strategy.MO_tex2")+'PN,'+this.$t("strategy.MO_tex1")+res.dat[1]+this.$t("strategy.MO_tex2")+','+this.$t("strategy.MO_tex3")+res.dat[2]+this.$t("strategy.MO_tex2"))
          }else{
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
            this.toStrategy();
          });
     }
    },
    // 返回升级策略列表
    toStrategy() {
      this.$emit("noticeStrategyNewBox", 1);
      // this.$router.push({
      //   path: "strategy",
      //   // query:{
      //   //   upgradeDeviceInfo: val,
      //   // }
      //   // name:"fileUserList",
      //   // params: {
      //   //   sn:val
      //   // },
      // });
    }
  },
//   计算时间范围
  computed: {
    // 开始时间：只能在 03:00–05:00 之间选
    startOpts() {
        if (!this.endTime) return { selectableRange: '03:00:00 - 05:00:00' }
        const t = new Date(this.endTime.getTime() - 60000)  // +60000 ms = +1 min
              .toTimeString()
              .slice(0, 8) 
      return { selectableRange: `03:00:00 - ${t}` }
    },
    // 结束时间：不能早于 startTime 03:00–05:00
    endOpts() {
      if (!this.startTime) return { selectableRange: '03:00:00 - 05:00:00' }
      const t = new Date(this.startTime.getTime() + 60000) // +60000 ms = +1 min
              .toTimeString()
              .slice(0, 8)  // HH:mm:ss
      return { selectableRange: `${t} - 05:00:00` }
    }
  }
};
</script>
  <style lang="less" scoped>
@import url("../../assets/css/mixin.less");
.addstategyNew {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
  margin: 20px;
  // 统一按钮

  .btn {
    height: 32px;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }
  /deep/.el-textarea__inner,
  .el-input__inner {
    background: #2b3842;
    color: #fff;
    border: 1px solid #a3a9b5;
  }
  /deep/.el-textarea__inner,
  .el-input__inner:focus {
    border: 1px solid #a3a9b5 !important;
  }
  // 时间"-"号调整
  /deep/.el-range-separator {
    line-height: normal !important;
    color: #fff !important;
  }
  // 时间图标
  /deep/.el-icon-date:before {
    content: "";
    display: inline-block;
    position: absolute;
    top: -6px;
    right: 10px;
    height: 24px;
    width: 24px;
    background: url(../../assets/img/general/Icon_Calendar.png) no-repeat;
    background-size: 100%;
    background-position: center;
  }
  /deep/.el-range-editor .el-range-input {
    background-color: #2b3842;
    color: #fff;
  }
  /deep/.el-form-item__label {
    color: rgba(255, 255, 255, 1);
  }
  /deep/.el-form-item {
    color: rgba(255, 255, 255, 1);
  }

  /deep/.el-input .el-input__inner {
    background-color: #2b3842;
    border: 1px solid #a3a9b5;
    color: #fff;
  }
  /deep/.el-select {
    width: 100%;
  }
  /deep/.el-radio__input.is-checked + .el-radio__label {
    color: @primaryTextColor !important;
  }
  /deep/.el-radio__input.is-checked .el-radio__inner {
    background: @primaryTextColor !important;
    border-color: #28d4c1 !important;
  }
  .section {
    flex: 1;
    display: flex;
    border-radius: 0px;
    border: none;
    flex-direction: column;
    background: rgb(34, 45, 53);
    padding: 0px;
    overflow: auto;
    .stategyHeader {
      display: flex;
      padding: 0 0 15px 0;
      font-size: 20px;
      color: #ffffff;
      align-items: center;
      background-color: #2d3f4b;
      i {
        font-size: 26px;
      }
      div:hover {
        cursor: pointer;
      }
      .toStyle {
        margin: 0 20px 0 5px;
      }
    }
    .stategyBody {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      .gridbox {
        .form-group {
          padding: 49px 46px 31px;
          margin-top: 50px;
          border: 1px solid rgba(255, 255, 255, 0.5);
          border-radius: 16px;
          position: relative;
          color: #fff;
          .showresultbox {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            // 图标
            .showsuccess {
              border: 3px solid rgba(37, 255, 174, 1);
              background-color: rgba(19, 195, 156, 1);
              background-image: url(../../assets/img/general/Icon_Finished.png);
              background-size: 70px 70px;
            }
            .showfail {
              border: 3px solid rgba(246, 189, 189, 1);
              background: rgba(251, 75, 75, 1);
              background-image: url(../../assets/img/general/Icon_Failed.png);
              background-size: 120px 120px;
            }
            .showbase {
              width: 100px;
              height: 100px;
              box-sizing: border-box;
              background-repeat: no-repeat;
              background-position: center;
              border-radius: 50%;
            }
            // 提示
            .showresulttext {
              font-weight: bold;
              font-size: 18px;
              margin-top: 20px;
              margin-bottom: 30px;
              color: rgba(255, 255, 255, 1);
            }
            // 操作
            .showoperate {
              text-align: center;
            }
            .showresultbtn {
              width: 102px;
              height: 30px;
              margin-top: 10px;
              border-radius: 6px;
              background: @primaryTextColor;
              color: rgba(34, 45, 53, 1);
              font-size: 14px;
            }
          }

          .search {
            margin: 0px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: rgb(34, 45, 53);

            .search-label {
              display: inline-block;
              color: #ffffff;
              font-weight: bold;
              line-height: 48px;
              font-size: 14px;
              padding-left: 16px;
            }

            /deep/.el-select {
              width: 100px;
              border-right: 1px solid #738089;
            }

            /deep/.el-select:hover {
              background: @primaryColorTransparency30;
            }

            /deep/.el-input {
              width: 100%;
              text-align: center;
            }

            /deep/.el-input__inner {
              background: transparent;
              border: none;
              height: 48px;
              line-height: 48px;
              color: #ffffff;
              padding: 0 16px;
            }

            /deep/.el-input__suffix {
              right: 0px;
            }

            .button {
              height: 48px;
              line-height: 48px;
              padding: 0 25px;
              margin-top: 0px;
              color: @primaryTextColor;
              background: transparent;
              border: none;
            }

            .search-alert {
              position: absolute;
              top: 0;
              // left: 0;
              right: 0;
              width: 100%;
              height: 48px;
              z-index: 1;
              background: rgb(34, 45, 53);
              display: flex;
              align-items: center;
              justify-content: space-between;

              .searchDiv {
                position: absolute;
                top: 0;
                // left: 0;
                right: 0;
                width: 400px;
                height: 48px;
                z-index: 2;
                background: rgb(34, 45, 53);
                display: flex;
                align-items: center;
                justify-content: space-between;
              }

              .searchAll {
                // display: flex;
                // align-items: center;
                // justify-content: flex-end;
                /deep/.el-input__inner {
                  width: 220px;
                  padding-left: 10px !important;
                }
              }

              .search-device {
                display: inline-block;
                line-height: 48px;
                padding: 0 15px;
                font-size: 14px;
                background: #202d35;
                color: #33ffb6;
                cursor: pointer;

                &:hover {
                  background: @primaryColorTransparency30;
                  color: rgb(255, 255, 255, 1);
                }
              }

              .search-hide {
                display: inline-block;
                // position: absolute;
                // right: -58px;
                line-height: 48px;
                padding: 0 15px;
                font-size: 14px;
                background: #202d35;
                color: #7b8395;
                border-left: 1px solid #7b8395;
                cursor: pointer;

                &:hover {
                  background: @primaryColorTransparency30;
                  color: rgb(255, 255, 255, 1);
                }
              }

              /deep/.el-input {
                flex: 1;
              }

              /deep/.el-input .el-input__clear {
                width: 48px;
                color: #7b8395;
              }

              /deep/.el-input .el-input__clear:hover {
                background: @primaryColorTransparency30;
                color: rgb(255, 255, 255, 1);
              }

              /deep/.el-input .el-input__inner,
              /deep/.el-input .el-input__inner:hover {
                height: 48px;
                border-radius: 0px;
                border: none;
                background: #202d35;
                color: #ffffff;
                padding-left: 40px;
              }

              /deep/.el-input__prefix {
                left: 0px;
              }

              /deep/.el-input__icon {
                width: 40px;
              }

              /deep/.el-input__suffix {
                right: 0px;
              }

              /deep/.el-input__suffix:hover {
                background: @primaryColorTransparency30;
                color: rgb(255, 255, 255, 1);
              }

              /deep/.el-icon-circle-close:before {
                content: "X";
              }

              /deep/.el-input:not(:last-child) {
                margin-right: 0px;
              }
            }

            /deep/.el-input:not(:last-child) {
              margin-right: 0px;
            }

            /deep/.el-select:not(:last-child) {
              margin-right: 0px;
            }

            // .searchLeft {}
            .searchRight {
              display: flex;
              justify-content: flex-end;
              position: relative;

              .buttonDeviceJurisdiction {
                padding: 0 17px 0 12px;
                background-color: @primaryTextColor;
                color: #222d35;
                border-radius: 0;

                span {
                  padding-left: 5px;
                }
              }
            }
          }

          .table {
            flex: 1;
            overflow: auto;

            /deep/.el-icon-loading {
              font-size: 28px;
            }
          }
          .tablemain {
            border: none;
            background-color: rgb(34, 45, 53);
            width: 100%;

            .operation i {
              color: @primaryTextColor;
            }

            /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
              width: 16px;
              height: 16px;
              background: transparent;
              border: 1px solid rgb(180, 184, 193);
              border-radius: 0px;
            }

            /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
              top: 2px;
              left: 5px;
            }

            /deep/.el-table__header th {
              height: 48px;
            }

            /deep/.el-table__header th.is-leaf {
              border-color: rgba(198, 209, 221, 0.5);
              // border-bottom: none;
            }

            /deep/.el-table__header th > .cell {
              font-weight: normal;
              font-size: 12px;
            }

            /deep/.el-table__body tr,
            /deep/.el-table__body td {
              background-color: rgb(34, 45, 53);
              color: #ffffff;
              border-color: rgba(198, 209, 221, 0.5);
            }

            /deep/.el-table__body td.el-table-column--selection {
              background-color: rgb(65, 80, 90);
              color: #ffffff;
            }

            /deep/.el-table__body .cell.el-tooltip {
              font-size: 14px;
            }

            /deep/.el-table__fixed-right::before,
            /deep/.el-table__fixed::before {
              display: none;
            }

            /deep/.el-table--border::after,
            /deep/.el-table--group::after {
              width: 0px;
            }

            ::-webkit-scrollbar {
              width: 6px;
              height: 6px;
              background-color: #222d35;
              z-index: 9999;
            }

            // 关于复选框
            /deep/.el-checkbox
              .el-checkbox__input.is-checked
              .el-checkbox__inner {
              background: @primaryTextColor;
              border: 1px solid @primaryTextColor;
            }

            /deep/.el-checkbox
              .el-checkbox__input.is-indeterminate
              .el-checkbox__inner {
              background: @primaryTextColor;
              border: 1px solid @primaryTextColor;
            }

            // 关于头部右侧空白
            /deep/.el-table__fixed-right-patch {
              background-color: rgb(65, 80, 90);
              border-bottom: none;
            }

            /deep/th.gutter {
              background-color: rgb(65, 80, 90);
            }

            // 关于表格右侧边线(无效)
            /deep/.el-table--border::after {
              display: none;
            }

            /deep/.el-table--group::after {
              display: none;
            }
          }

          .tablebottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-top: 1px solid rgba(198, 209, 221, 0.5);

            // 分页
            .pagination {
              line-height: 48px;
              height: 48px;
              padding: 0;
              margin: 0;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              margin-right: 16px;

              /deep/.el-pager li {
                vertical-align: middle;
              }

              /deep/.el-select .el-input {
                width: 90px;
                margin: 0px;
              }

              /deep/.el-input .el-input__inner {
                background-color: #202d35;
                color: #ffffff;
              }

              /deep/.el-input__suffix {
                right: 10px;
              }

              /deep/.el-pagination__sizes {
                margin: 0px;
                height: 48px;
                line-height: 48px;
              }

              /deep/.el-pagination__total {
                color: #fff;
                padding-left: 15px;
                border-left: 1px solid #7b8395;
                height: 48px;
                line-height: 48px;
              }

              /deep/.el-pager li:not(.disabled).active {
                // background: #15C491;
                // color: #ffffff;
                background-color: #2b3842;
                color: #15c491;
              }

              // li:not(.disabled):not(.active):hover
              /deep/.el-pager li:not(.disabled):hover {
                background-color: @primaryColorTransparency30;
                color: rgba(255, 255, 255, 1);
              }

              /deep/.el-pager li {
                background-color: #2b3842;
                color: #7b8395;
              }

              // 页条数下拉
              /deep/.el-select .el-input .el-input__inner {
                border: none;
                height: 48px;
                line-height: 48px;
                border-radius: 0px;
              }

              /deep/.el-select .el-input .el-input__inner:hover {
                background: @primaryColorTransparency30;
              }

              // 跳页
              /deep/.el-pagination__jump {
                color: #ffffff;
              }

              /deep/.el-pagination__editor {
                padding: 0px 6px;
              }

              /deep/.el-pagination__editor.el-input .el-input__inner {
                border: 1px solid #7b8395;
              }
            }

            // 分页前后按钮
            /deep/.el-pagination.is-background .btn-next,
            /deep/.el-pagination.is-background .btn-prev {
              background-color: #2b3842;
              color: #7b8395;
            }

            /deep/.el-pagination.is-background .btn-next:hover,
            /deep/.el-pagination.is-background .btn-prev:hover {
              background-color: @primaryColorTransparency30;
              color: rgba(255, 255, 255, 1);
            }

            /deep/.el-pagination.is-background button[disabled],
            /deep/.el-pagination.is-background button[disabled]:hover {
              background-color: #2b3842;
              color: #7b8395;
            }
          }
          /deep/.dialog-content .el-form-item--small .el-form-item__label {
            line-height: 40px;
          }

          /deep/.latlon .el-form-item__content {
            display: block;
          }
          /deep/.linkage .el-form-item__content {
            display: block;
          }

          /deep/.dialog-content
            .el-form-item--small.linkage
            .el-form-item__label {
            display: block;
            width: 100%;
            text-align: left;
            line-height: 40px;
          }

          /deep/.el-icon-arrow-up:before {
            color: @primaryTextColor;
          }
          // 时间图标
          /deep/.el-icon-date:before {
            left: 10px;
            content: "";
            display: inline-block;
            margin-top: 8px;
            height: 24px;
            width: 24px;
            background: url(../../assets/img/general/Icon_Calendar.png)
              no-repeat;
            background-size: 100%;
            background-position: center;
          }

          // /deep/.el-input .el-input__inner {
          //   height: 40px;
          //   line-height: 40px;
          // }

          /deep/.el-input-group__append,
          /deep/.el-input-group__prepend {
            background: #2b3842;

            .el-dropdown {
              color: #ffffff;
            }

            .el-icon-arrow-down:before {
              color: @primaryTextColor;
            }
          }
        }

        .form-groupname {
          position: absolute;
          top: -20px;
          left: 50px;
          .sc(26px, #ffffff);
          font-weight: 600;
          background: #222d35;
          padding: 0 8px;
        }
        .fileYupe{
            max-width: 99%;
            height: 20px;
            margin-left: 10px;
            -webkit-backdrop-filter: blur(6px);
              box-shadow: 0px 1px 3.1px 0px rgba(255, 255, 255, 1) inset;
              box-shadow: -1px -1px 4.7px 0px rgba(11, 129, 255, 0.12) inset;
              box-shadow: 0px 1px 10.9px 0px rgba(177, 174, 174, 0.15);
            border-radius:4px ;
            padding-left: 6px;
            margin-bottom: 4px;
            display: flex;
            align-items: center;
        }
      }

      ::v-deep {
        .el-step__title.is-process,
        .el-step__title.is-wait {
          color: #fff;
        }
        .el-step__head.is-process,
        .el-step__heads.is-wait {
          .el-step__icon.is-text {
            //这里设置的是下一步和等待状态里的文字颜色
            color: #fff !important;
            border-color: @primaryTextColor !important;
            background-color: @primaryTextColor !important;
          }
          .el-step__main {
            .ai-step__title,
            .el-step__description {
              // color: @primaryTextColor !important;
            }
            .el-step__title.is-process {
              color: @primaryTextColor !important;
            }
          }
        }
        .el-step__head.is-finish {
          color: @primaryTextColor !important;
          .el-step__icon.is-text {
            //这里设置的是已完成状态里的文字颜色
            color: @primaryTextColor !important;
            border-color: @primaryTextColor !important;
          }
        }
        .el-step__title.is-finish {
          color: @primaryTextColor !important;
        }
        .el-step__line-inner {
          //这里设置的是完成后过渡线条颜色
          border-color: @primaryTextColor !important;
        }
        .el-step__head.is-success,
        .el-step__title.is-success {
          //这里设置的是完成后的颜色
          background-color: @primaryTextColor !important;
        }
      }
    }
  }
}
</style>
  <style lang="less">
// #下拉选框#
.select-search-recharge {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 4px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.hover {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 0px;
  }

  // 滚动条
  ::-webkit-scrollbar {
    // width: 0px;
    // height: 0px;
    background-color: transparent;
  }
}

.select-search-project {
  .el-select-dropdown__list {
    padding: 0 16px;
  }

  .el-select-dropdown__item {
    height: 40px;
    line-height: 40px;
    box-shadow: 0px 0.5px rgba(164, 182, 200, 0.2);
  }
}

// 控制项日期选择样式
.select-date .el-input .el-input__inner,
.select-date .el-picker-panel__footer {
  background: #222d35;

}
.select-date .el-button {
  background: #222d35;
  color: @primaryTextColor;

  &:hover {
    background: #222d35;
    color: @primaryTextColor;
  }
}

.selectClearNew {
  // 下拉选中清除按钮
  .el-icon-circle-close:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../assets/img/general/Icon_SelectClear.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    // position: absolute;
    // top: 8px;
    // right: 16px;
  }
}

.deviceName .el-tooltip {
  color: @primaryTextColor;
}
.select-search-recharge {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 4px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.hover {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 0px;
  }
}
// #分页下拉框#
.select-page {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 12px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
    background-color: rgb(34, 45, 53);
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
    min-width: 110px;
  }

  .el-select-dropdown__item.hover {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 16px;
  }

  &[x-placement^="top"] .popper__arrow {
    display: none;
  }
}
.select-date2.el-time-panel{
    background-color: #2b3842 ;
    .el-time-spinner__item.active:not(.disabled){
    color: #fff;
  }
  .el-time-spinner__item:hover:not(.disabled):not(.active){
    background: #15c491;
    color: #FFF;
  }
  .el-button--default{
    background: var(--primaryTextColor, #30D096);
    color: #222d35;
    border: none;
}
.el-button.is-disabled.is-plain, .el-button.is-disabled.is-plain:focus, .el-button.is-disabled.is-plain:hover{
    background: var(--primaryColorTransparency30, #30d0956e);
    color: #C0C4CC;
}
.el-button--text{
    color: rgba(48, 208, 150);
    display: none;
}
.el-button--text:hover{
    color: rgba(48, 208, 150);
}
.el-time-panel__btn{
    color: rgba(48, 208, 150);
}
}

.select-date1.el-picker-panel {
  background-color: #222d35;
  border: none;
  padding-top: 10px;
  .el-date-table td.current:not(.disabled) span{
    background-color: #30d096;
  }
  .el-picker-panel__body-wrapper {
    .el-picker-panel__body {
      border: #222d35;
    }
    .el-picker-panel__sidebar {
      width: 100%;
      position: relative;
      padding: 0px;
      background: transparent;
      color: #ffffff;
      border: none;
      .el-picker-panel__shortcut,
      .el-picker-panel__shortcut:hover {
        // margin-top: 0px;
        padding-left: 0px;
        padding-bottom: 20px;
        color: rgba(48, 208, 150, 1);
        text-align: center;
      }
    }
  }
//   .el-date-range-picker__editor{
//     pointer-events: none;
//   }
  .el-time-panel{
    background: #2b3842;
  }
  .el-time-spinner__item.active:not(.disabled){
    color: #fff;
  }
  .el-time-spinner__item:hover:not(.disabled):not(.active){
    background: #15c491;
    color: #FFF;
  }
&.el-popper[x-placement^=top] .popper__arrow::after{
    border-top-color: #222d35;
}
.el-button--default{
    background: var(--primaryTextColor, #30D096);
    color: #222d35;
    border: none;
}
.el-button.is-disabled.is-plain, .el-button.is-disabled.is-plain:focus, .el-button.is-disabled.is-plain:hover{
    background: var(--primaryColorTransparency30, #30d0956e);
    color: #C0C4CC;
}
.el-button--text{
    color: rgba(48, 208, 150);
    display: none;
}
.el-button--text:hover{
    color: rgba(48, 208, 150);
}
.el-time-panel__btn{
    color: rgba(48, 208, 150);
}
  .el-picker-panel__footer{
    background: #2b3842;
  }
  .el-input__inner {
    background: #2b3842;
    color: #fff;
    border: 1px solid #a3a9b5;
  }
  .el-date-range-picker__header {
    color: #fff;
  }
  .el-date-table td.end-date span,
  .el-date-table td.start-date span {
    background-color: rgba(48, 208, 150, 0.8);
    border: rgba(48, 208, 150);
  }
  .in-range {
    background-color: #222d35;
  }
  .el-picker-panel__shortcut:hover {
    padding-left: 0px;
    padding-bottom: 20px;
    color: rgba(48, 208, 150, 1);
    text-align: center;
  }
  .el-date-table td.today span {
    color: rgba(48, 208, 150, 1);
    font-weight: 700;
  }
  .el-date-table td.start-date span {
    color: #fff;
    font-weight: 700;
  }
  .el-date-table td.end-date span {
    color: #fff;
    font-weight: 700;
  }
  .el-date-table td.in-range div {
    background-color: rgba(48, 208, 150, 0.7);
  }
  .el-picker-panel__icon-btn {
    color: rgba(48, 208, 150);
    font-size: 14px;
    font-weight: bold;
  }
  .el-date-table td.in-range {
    background-color: #222d35;
  }
  .el-date-table td:hover {
    color: rgba(48, 208, 150);
  }
  .el-date-table td.next-month,
  .el-date-table td.prev-month {
    color: #606266;
  }
  .el-date-table td {
    color: #fff;
  }
}
  // 上传固件二次弹窗
  .upload-contents {
    border-radius: 6px;
    border: 1px dashed rgba(255, 255, 255, 0.5);
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .upload-buttonEquipment {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 6px 16px 6px 10px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 14px;

      i {
        color: rgb(56, 165, 118);
        font-size: 32px;
      }
    }

    .upload-input {
      display: none;
    }
  }
</style>